import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";

const EP_IMG =
  "https://images.unsplash.com/photo-1631867519984-2eb223627ddb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";

const FACTS = ["2–6 players", "90 minutes", "Candle & ritual kit included"];

export const EpisodeOne = () => (
  <section
    id="episode"
    data-testid="episode-section"
    className="mx-auto max-w-7xl px-6 py-24 sm:px-12 sm:py-36"
  >
    <div className="grid grid-cols-1 items-center gap-16 lg:grid-cols-12">
      <Reveal className="order-2 lg:order-1 lg:col-span-5">
        <div className="group relative">
          <div className="overflow-hidden rounded-t-[10rem] border border-gold/20 shadow-[0_40px_100px_rgba(0,0,0,0.6)]">
            <img
              data-testid="episode-one-image"
              src={EP_IMG}
              alt="The wax-sealed Séance box and letters"
              loading="lazy"
              className="aspect-[4/5] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
            />
          </div>
          <motion.span
            aria-hidden="true"
            animate={{ y: [0, -8, 0] }}
            transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
            className="absolute -right-4 top-8 font-cinzel text-7xl text-gold/30 sm:-right-8"
          >
            I.
          </motion.span>
        </div>
      </Reveal>
      <Reveal delay={0.15} className="order-1 lg:order-2 lg:col-span-7">
        <p className="font-cinzel text-[11px] tracking-[0.45em] text-gold/80">
          NOW SHOWING — EPISODE ONE
        </p>
        <h2 className="mt-6 font-serif text-4xl font-light leading-tight text-cream sm:text-6xl">
          The <em className="italic text-gold">Séance.</em>
        </h2>
        <p
          data-testid="episode-one-copy"
          className="mt-8 max-w-xl text-base leading-relaxed text-sand sm:text-lg"
        >
          A sealed box of theatre arrives by ordinary post. Dim the lights, gather
          a circle of two to six, break the wax — and spend ninety minutes in the
          company of the other side. The house remembers every choice you make.
        </p>
        <div className="mt-8 flex flex-wrap gap-x-8 gap-y-3">
          {FACTS.map((fact) => (
            <span
              key={fact}
              className="text-[11px] uppercase tracking-[0.2em] text-ash"
            >
              {fact}
            </span>
          ))}
        </div>
        <div className="mt-10 flex flex-wrap items-center gap-5">
          <button
            data-testid="episode-reserve-button"
            onClick={() => scrollToId("#join")}
            className="rounded-full bg-gold px-8 py-4 text-[12px] font-semibold uppercase tracking-[0.22em] text-obsidian transition-all duration-300 hover:bg-gold-glow hover:shadow-[0_0_40px_rgba(226,177,93,0.35)]"
          >
            Reserve Box Nº 001
          </button>
          <button
            data-testid="episode-ritual-button"
            onClick={() => scrollToId("#ritual")}
            className="rounded-full border border-cream/20 px-8 py-4 text-[12px] uppercase tracking-[0.22em] text-cream transition-colors duration-300 hover:border-gold/60 hover:text-gold"
          >
            Commune first
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
